import React from "react"

const TITLE_CONTENT = [
  "Finally, we will look at how the two platforms compare when it comes to pricing. When choosing a new software tool for selling on Amazon or any other business, the cost will likely play a big role in which solution is best for you.",
  "Below, you can see the pricing plans for AMZScout and Jungle Scout.",
]
export default TITLE_CONTENT
